<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>upp-address</h2>
            <p class="demo-description">Delivery address input — shows <code>upp-address</code> with form integration and live value output.</p>

            <div class="demo-section" [formGroup]="form">
    <h3>Delivery Address</h3>

    <div class="demo-note">
        <ion-icon name="information-circle-outline"></ion-icon>
        Requires Google Maps API key for autocomplete and map display.
    </div>

    <div class="demo-field">
        <label class="demo-label">Address</label>
        <upp-address
            formControlName="address"
            placeholder="Enter delivery address..."
            title="Delivery Address">
        </upp-address>
    </div>
</div>

<!-- Live form value -->
<div class="demo-section">
    <h3>Form Value</h3>
    <pre class="form-value-output">{{ formValueJson }}</pre>
</div>
        </div>
    </upp-scrollable>
</div>
